<template>
  <div>
    <el-dialog
      :title='modalTitle'
      :visible.sync='showModal'
      width='90%'
      :lock-scroll='false'
      max-width='500px'
    >
      <div class='col-sm-12 col-xs-12 entrada'>
        <div class='col-sm-3 col-xs-3'>
          <label>Nombre</label>
        </div>
        <div class='col-sm-9 col-xs-9 contact-form-field' v-if='editing'>
          <p>{{ contact.name }}</p>
        </div>
        <div class='col-sm-9 col-xs-9 contact-form-field' v-else>
          <el-input
            type='text'
            name='nombre'
            required
            placeholder='Nombre'
            v-model='contact.name'
          ></el-input>
          <!-- <span>{{ errors.first('nombre') }}</span> -->
        </div>
        <div class="col-sm-3 col-xs-3">
          <label>Email</label>
        </div>
        <div class="col-sm-9 col-xs-9 contact-form-field" v-if="editing">
          <p>{{ contact.user }}</p>
        </div>
        <div class="col-sm-9 col-xs-9 contact-form-field" v-else>
          <el-input
            v-validate="'required|email'"
            name="email"
            type="text"
            required
            placeholder="Email"
            v-model="contact.user"
          ></el-input>
          <!-- <span>{{ errors.first('email') }}</span> -->
        </div>
        <div
          class="col-sm-3 col-xs-3"
          v-if="user.roles.every((rol) => rol.rolesId != 20) && this.user.isAdmin != 1"
        >
          <label>Empresa</label>
        </div>
        <div
          class="col-sm-9 col-xs-9 contact-form-field"
          v-if="user.roles.every((rol) => rol.rolesId != 20) && this.user.isAdmin != 1"
        >
          <el-select v-model="contact.idCompany" placeholder="Seleccione Compania">
            <el-option
              v-for="item in providers"
              :key="item.idCompany"
              :label="item.company"
              :value="item.idCompany"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-sm-3 col-xs-3" v-if="user.roles.find((rol) => rol.rolesId == 20)">
          <label>Empresa</label>
        </div>
        <div
          class="col-sm-9 col-xs-9 contact-form-field"
          v-if="user.roles.find((rol) => rol.rolesId == 20)"
        >
          <el-select
            v-model="contact.idCompany"
            placeholder="Seleccione Compania"
            disabled
          >
            <el-option
              v-for="item in providers"
              :key="item.idCompany"
              :label="item.company"
              :value="item.idCompany"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-md-9 col-xs-9 entrada" v-if="editing">
          <div class="col-md-3 col-xs-3">
            <label>Estado</label>
          </div>
          <div
            class="col-md-9 col-xs-9 contact-form-field"
            v-if="user.roles.every((rol) => rol.rolesId != 20)"
          >
            <el-select
              v-model="contact.idProviderStatus"
              placeholder="Seleccione Estado"
              v-if="contact.active"
            >
              <el-option :value="'2'" :label="'Activo'"></el-option>
              <el-option :value="'6'" :label="'Rechazado'"></el-option>
              <el-option :value="'5'" :label="'Suspendido'"></el-option>
            </el-select>
            <p v-if="!contact.active">Solicitado</p>
          </div>
          <div
            class="col-md-9 col-xs-9 contact-form-field"
            v-if="user.roles.find((rol) => rol.rolesId == 20)"
          >
            <el-select
              v-model="contact.idProviderStatus"
              placeholder="Seleccione Estado"
              disabled
              v-if="contact.active"
            >
              <el-option :value="'2'" :label="'Activo'"></el-option>
              <el-option :value="'6'" :label="'Rechazado'"></el-option>
              <el-option :value="'5'" :label="'Suspendido'"></el-option>
            </el-select>
            <p v-if="!contact.active">Solicitado</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary" v-on:click="saveContact()" v-if="editing">
          Guardar
        </button>
        <button class="btn btn-primary" v-on:click="createContact()" v-else>Crear</button>
        <button class="btn" v-on:click="hideModal()">Cancelar</button>
      </span>
    </el-dialog>

    <section class="content">
      <div class="box-body">
        <div class="">
          <div style="margin-bottom: 10px">
            <el-row>
              <el-col :span="6">
                <el-button
                  @click="modalAddContact"
                  type="primary"
                  icon="el-icon-plus"
                  v-if="user.roles.every((rol) => rol.rolesId != 20)"
                  >Agregar</el-button
                >
              </el-col>
              <el-col :span="6">
                <el-input v-model="filters[0].value" placeholder="Buscar"></el-input>
              </el-col>
              <el-col :span="8">
                <el-select multiple v-model="filters[1].value" placeholder="Estado">
                  <el-option
                    v-for="item in providerStatus"
                    :key="item.idProviderStatus"
                    :value="item.idProviderStatus"
                    :label="item.description"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
          <data-tables
          class="licitaciones__table-mobile"
            :data="contacts"
            :pagination-props="{ pageSizes: [10, 20, 30] }"
            :table-props="{ defaultSort: { prop: 'status', order: 'descending' } }"
            :filters="filters"
          >
            <el-table-column
              v-for="title in titles"
              :prop="title.prop"
              :label="title.label"
              :key="title.prop"
              sortable="custom"
            >
            </el-table-column>
            <el-table-column label="" :align="'center'">
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Enviar mail activación"
                  placement="top"
                  v-if="scope.row.status === 'Solicitado'"
                >
                  <el-button
                    type="primary"
                    icon="el-icon-message"
                    circle
                    @click="sendActivationMail(scope.row)"
                    v-if="user.roles.every((rol) => rol.rolesId != 20)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Detalles"
                  placement="top-end"
                >
                  <el-button
                    type="primary"
                    icon="el-icon-view"
                    circle
                    @click="viewDetails(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
require('moment')
import datepicker from 'vue-date-picker'
import Vue from 'vue'
import api from '../../api'
import ElementUI from 'element-ui'
import DataTables from 'vue-data-tables'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/es'
import locale from 'element-ui/lib/locale'
import { mapState } from 'vuex'

Vue.use(ElementUI)
locale.use(lang)
Vue.use(DataTables)

export default {
  name: 'Settings',
  components: {
    datepicker
  },
  data (router) {
    return {
      providerStatus: [],
      providers: [],
      currentProviderId: '',
      editing: false,
      modalTitle: '',
      section: 'AllProviders',
      loading: '',
      showModal: false,
      contact: {
        name: '',
        email: '',
        idProviderStatus: '',
        idCompany: ''
      },
      titles: [
        {
          // Columnas que se van a mostrar
          prop: 'user',
          label: 'Usuario'
        },
        {
          prop: 'company',
          label: 'Compañía'
        },
        {
          prop: 'fiscalId',
          label: 'Identificación Fiscal'
        },
        {
          prop: 'idType',
          label: 'Tipo de identificación'
        },
        {
          prop: 'date',
          label: 'Fecha'
        },
        {
          prop: 'status',
          label: 'Estado'
        }
      ],
      filters: [
        {
          prop: ['user', 'company', 'status'],
          value: ''
        },
        {
          prop: ['idProviderStatus'],
          value: ''
        }
      ]
    }
  },
  computed: {
    ...mapState(['user']),
    datetime () {
      return new Date()
    },
    contacts () {
      if (this.user.isProvider && this.user.isAdmin === '1') {
        return this.$store.state.contacts
          .slice()
          .sort((a, b) => {
            return a.status - b.status
          })
          .filter((element) => element.idCompany === this.user.idCompany)
      } else {
        return this.$store.state.contacts.slice().sort((a, b) => {
          return a.status - b.status
        })
      }
    }
    // providers () {
    //   return this.$store.state.providers.slice().sort((a, b) => a.status - b.status)
    // }
  },
  methods: {
    modalAddContact () {
      this.contact = {
        name: '',
        mail: '',
        idProviderStatus: '',
        idCompany: ''
      }
      this.modalTitle = 'Agregar un contacto'
      this.editing = false
      this.showModal = true
    },

    getProviderStatus () {
      api.request('GET', 'api/generic/statusProvider').then((response) => {
        this.providerStatus = response.data
      })
    },

    createContact () {
      if (this.user.isAdmin) {
        this.contact.idCompany = this.user.company.idCompany
      }
      api
        .request(
          'POST',
          'api/generic/user',
          JSON.stringify({
            name: this.contact.name,
            requiresNewPassword: 0,
            email: this.contact.user,
            idCompany: this.contact.idCompany
          })
        )
        .then((response) => {
          api
            .request(
              'POST',
              'api/generic/provider',
              JSON.stringify({
                idCompany: this.contact.idCompany,
                idUser: response.data.idUser,
                idComments: 0,
                idProviderStatus: 1,
                providerDeleted: 0,
                calification: 0,
                reasonCalification: 0,
                aceptoTerminos: 0
              })
            )
            .then((response) => {
              this.showModal = false
              this.$parent.getContacts()
              this.$message({
                type: 'success',
                message: 'Se ha creado el contacto'
              }).catch((error) => {
                console.log(error)
                this.$message({
                  type: 'danger',
                  message: 'Error al crear el contacto'
                })
              })
              //  this.sendActivationMail(response.data)
            })
        })
    },
    saveContact () {
      console.log(this.contact)
      api
        .request(
          'POST',
          'api/generic/provider/' + this.currentProviderId,
          JSON.stringify({
            idCompany: this.contact.idCompany,
            idProviderStatus: this.contact.idProviderStatus
          })
        )
        .then((response) => {
          this.showModal = false
          this.$parent.getContacts()
          this.$message({
            type: 'success',
            message: 'Se ha guardado el contacto'
          })
        })
        .catch((error) => {
          console.log(error)
          this.$message({
            type: 'danger',
            message: 'Error al guardar el contacto'
          })
        })
    },
    sendActivationMail (row) {
      this.$confirm(
        '¿Está seguro que desea enviar el mail de activación a este usuario?',
        'Atención',
        {
          confirmButtonText: 'Enviar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      ).then(() => {
        api
          .request('GET', 'api/sendMailProvider/Provider/' + row.idProvider)
          .then((response) => {
            this.$parent.getContacts()
            this.$message({
              type: 'success',
              message: 'Se ha enviado el email'
            })
          })
          .catch((error) => {
            console.log(error)
            this.$message({
              type: 'danger',
              message: 'Error al enviar el email'
            })
          })
      })
    },
    detail (row) {
      this.$router.push('/contactDetail?u=' + row.idProvider)
    },
    viewDetails (row) {
      this.currentProviderId = row.idProvider
      this.contact = JSON.parse(JSON.stringify(row))
      this.modalTitle = 'Editar Contacto'
      this.editing = true
      this.showModal = true
      return
    },
    hideModal () {
      this.showModal = false
    },
    getProviders () {
      this.$store.commit('START_LOADING')
      api
        .request('GET', 'api/generic/company?select=idCompany,company')
        .then((response) => {
          this.providers = response.data
          console.log(this.providers)
          this.$store.commit('STOP_LOADING')
        })
        .catch((error) => {
          console.log(error)
          this.$store.commit('STOP_LOADING')
        })
    },
    getProviderTest () {
      api
      .request('GET', 'api/generic/provider')
      .then((response) => {
        this.providers = response.data
      })
      .catch((error) => {
        console.log(error)
      })
    }
  },
  beforeMount () {
    this.getProviderStatus()
    // this.getProviders()
    this.getProviderTest()
  }
}
</script>

<style>
@media screen and (max-width: 550px){
  .el-select{
    max-width: 100%;
  }
}
.datetime-picker input {
  height: 4em !important;
}

.calification-reason {
  margin-top: 20px;
  border-radius: 5px;
  background-color: #eee;
}

.height-enter-active {
  transition: all 0.4s ease-in-out;
}

.height-enter,
.height-leave-to {
  transform: scaleY(0);
}

.el-dialog_wrapper,
.el-dialog {
  overflow: hidden !important;
}

.el-dialog .el-table {
  height: calc(100vh - 278.87px);
  overflow: auto !important;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.contact-form-field {
  padding-top: 12px;
}
</style>



// WEBPACK FOOTER //
// AllContacts.vue?5d613f24